import InitializeUserPreferences from './preferences/InitializeUserPreferences';

export default class UpdateOnboardingStep {
  constructor(userRepository) {
    this.userRepository = userRepository;
  }

  async execute(uid, stepId, stepData = {}) {
    
    const userData = {
      onboardingStep: stepId,
      updatedAt: new Date().toISOString()
    };

    const currentOnboardingData = stepData.onboardingData || {};
    const mergedData = {
      ...currentOnboardingData,
      ...stepData
    };

    // Mapping des données selon l'étape
    switch (stepId) {
      case 'welcome':
        break;

      case 'phone':
        userData.phone = mergedData.phone || '';
        userData.phoneVerified = mergedData.phoneVerified || false;
        break;

      case 'birthday':
        userData.birthday = mergedData.birthday || null;
        break;

      case 'activities':
        userData.interests = mergedData.interests || [];
        break;

      case 'location':
        userData.location = mergedData.location;
        break;

      case 'photo':
        userData.photoURL = mergedData.photoURL || null;
        break;

      case 'completion':
        // Récupérer les données existantes pour s'assurer qu'on a les valeurs correctes
        const existingUser = await this.userRepository.getUser(uid);
        
        userData.onboardingCompleted = true;
        userData.credits = 5;
        userData.badges = ['welcome'];

        // Conserver la location de l'utilisateur existant en priorité
        // ou utiliser celle des données d'onboarding si disponible
        if (existingUser.location) {
          userData.location = existingUser.location;
        } else if (mergedData.location) {
          // S'assurer que le format est correct
          userData.location = {
            address: mergedData.location.address || '',
            placeId: mergedData.location.placeId || '',
            coordinates: mergedData.location.coordinates || {
              latitude: mergedData.location.location?.lat,
              longitude: mergedData.location.location?.lng
            }
          };
        }
        
        if (mergedData.photoURL) {
          userData.photoURL = mergedData.photoURL;
        }
 
        const initializer = new InitializeUserPreferences(this.userRepository);
        await initializer.execute(uid, { language: stepData.language });
        
        // Ne plus stocker les données d'onboarding à la complétion
        userData.onboardingData = null;
        
        break;

      default:
        console.warn(`Étape d'onboarding inconnue: ${stepId}`);
        break;
    }

    if (stepId !== 'welcome' && stepId !== 'completion') {
      userData.onboardingData = {
        phone: mergedData.phone || '',
        phoneVerified: mergedData.phoneVerified || false,
        birthday: mergedData.birthday || null,
        activities: mergedData.interests || [],
        location: mergedData.location,
        photoURL: mergedData.photoURL || null
      };
    }

    const cleanedUserData = Object.entries(userData).reduce((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = value;
      }
      return acc;
    }, {});

    return this.userRepository.updateUser(uid, cleanedUserData);
  }
}